import styled from 'styled-components';
import { ACCENT_COLOR, BODY_TEXT_COLOR, FUTURA_BOLD, NEGATIVE_COLOR, ERROR_COLOR } from '../../config/colors';
import IdScanBackground from './images/idscan-background.png';

const media768 = '@media all and (max-width: 768px)';
const media568 = '@media all and (max-width: 568px)';
const mediaHeight660 = '@media all and (max-height: 660px) and (max-width: 568px)';

export const styles = {
  inputField: {
    width: '100%',
    color: BODY_TEXT_COLOR
  },
  paymentKioskInputField: {
    color: BODY_TEXT_COLOR,
    height: '120px',
    width: '100%'
  },
  paymentKioskInputStyle: {
    fontSize: '50px',
  },
  floatingLabelStyle: {
  },
  paymentKioskFloatingLabelStyle: {
    fontSize: '10px',
    height: '100px!important'
  },
  submitBtn: {
    height: '42px',
    lineHeight: '42px'
  },
  submitBtnLabel: {
    width: '100%',
    height: '42px',
    lineHeight: '42px',
    color: '#fff'
  },
  paymentKioskSubmitBtnLabel: {
    color: '#fff',
    fontSize: '40px',
    fontWeight: '800'
  },
  paymentKioskSubmitBtn: {
    height: '100px'
  },
  submitBtnOverlayStyle: {
    height: '42px'
  },
  submitBtnErrorStyle: {
    position: 'absolute',
    bottom: '-15px',
    fontSize: '14px'
  },
  linearProgress: {
    marginBottom: '20px'
  },
  closeIcon: {
    fontSize: '30px',
    color: BODY_TEXT_COLOR
  },
  closeIconLarge: {
    fontSize: '80px',
    color: BODY_TEXT_COLOR
  },
  noteLabelStyle: {
    top: '15px!important',
    lineHeight: '15px!important',
    wordBreak: 'break-all',
    transform: 'none!important'
  },
  noteLongLabelStyle: {
    top: '0px!important',
    lineHeight: '15px!important',
    wordBreak: 'break-all',
    transform: 'none!important'
  }
};

export const Form = styled.form`
  max-height: 100vh;
  margin-left: 20px;
  margin-right: 20px;
  
  ${media768} {
    margin-left: 0;
    margin-right: 0;
  }
`;

// should be used inside 'positioned' components
export const FormLoader = styled.div`
  display: ${props => (props.loading ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.7);
`;

export const FormLogo = styled.div`
  display: none;
  width: 43px;
  height: 60px;
  background: url(${process.env.PUBLIC_URL}/assets/img/treez-sm.png) no-repeat center;
  margin: 10% auto 20px;
  
  ${media568} {
    display: block;
  }
`;

export const Content = styled.div`
  padding: ${props => (props.compact ? '40px 40px 30px' : '50px 40px')};
  
  ${media768} {
    padding: 30px 25px;
  }
  
  ${media568} {
    display: flex;
    flex-flow: column nowrap;
    min-height: calc(100vh - 50px);
    padding: 0 20px 20px;
  }
  
  ${mediaHeight660} {
    display: block;
  }
`;

export const Header = styled.div`
  margin-bottom: 5px;
  font-size: 35px;
  font-weight: 900;
  font-family: ${FUTURA_BOLD};
  text-align: center;
  color: ${BODY_TEXT_COLOR};
`;

export const KioskHeader = styled.div`
  margin-bottom: 5px;
  font-size: 50px;
  font-weight: 900;
  font-family: ${FUTURA_BOLD};
  text-align: center;
  color: ${BODY_TEXT_COLOR};
`;

export const FormDescription = styled.p`
  color: ${BODY_TEXT_COLOR};
  text-align: center;
  font-size: 16px; 
`;

export const KioskFormDescription = styled.p`
  color: ${BODY_TEXT_COLOR};
  text-align: center;
  font-size: 44px; 
`;

export const SubmitBtnWrap = styled.div`
  margin-bottom: ${props => (props.compact ? '0' : '40px')};
  
  ${mediaHeight660} {
    margin-bottom: 30px;
  }
  
  ${media568} {
    margin-bottom: 15px;
  }
`;

export const FieldsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: ${props => (props.compact ? '30px' : '55px')};
  margin-left: -15px;
  margin-right: -15px;
  
  ${media768} {
    margin-bottom: 18px;
  }
  
  ${media568} {
  }
`;

export const FieldWrap = styled.div`
  width: ${props => props.width || '100%'};
  margin-bottom: ${props => (props.compact ? '0' : '10px')};
  margin-right: 15px;
  margin-left: 15px;
  font-size: ${props => (props.compact ? '14px !important' : 'inherit')};
  
  & > * {
    font-size: ${props => (props.compact ? '14px !important' : 'inherit')};
  }
`;

export const ResetPasswordLink = styled.div`
  display: inline-block;
  margin-left: auto;
  margin-right: 15px;
  position: relative;
  top: -10px;
  z-index: 5;
  text-align: right;
  cursor: pointer;
  color: ${BODY_TEXT_COLOR};
  
  &:hover {
    transition: color .2s;
    color: ${ACCENT_COLOR};
  }
`;

export const CloseBtn = styled.div`
  position: absolute;
  right: 10px;
  top: 20px; 
  cursor: pointer;
  
  ${media568} {
    right: 20px;
    top: 0;
  }
`;

export const AdditionalBlocks = styled.div`
`;

export const AdditionalBlock = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid ${NEGATIVE_COLOR};
  padding-top: 30px;
  padding-bottom: 30px;
  
  &:last-child {
    padding-bottom: 0;
  }
  
  & > * {
    flex: 1;
    min-width: auto !important;
  }
  
  & > *:first-child {
    padding-right: 15px;
  }
  
  & > *:last-child {
    padding-left: 15px;
  }
  
  ${media768} {
    padding-top: 15px;
    padding-bottom: 15px
  }
  
  ${mediaHeight660} {
    display: inline-block;
    width: calc(50% - 7.5px);
    
    &:nth-child(odd) {
      padding-right: 7.5px;
    }
    
    &:nth-child(even) {
      padding-left: 7.5px;
    }
    
    & > *:first-child {
      padding-right: 0;
    }
    & > *:last-child {
      padding-left: 0;
    }
  }
  
  ${media568} {
    width: 100%;
    padding: 0;
    border-width: 0;
    &:nth-child(odd) {
      padding-right: 0;
    }
  }
`;

export const AdditionalBlockText = styled.div`
  text-align: right;
  color: ${BODY_TEXT_COLOR};
  
  ${mediaHeight660} {
    display: none;
  }
`;

export const ScanIdWrapper = styled.div`
  color: ${BODY_TEXT_COLOR};
  font-size: 1.8em;
  background: url(${IdScanBackground}) bottom right no-repeat;
  background-size: 525px auto;
  height: 520px;
  margin-top: 2em;
  padding-right: 8em;

  p {
      margin-top: 0;
  }

  & > p {
    color: ${ACCENT_COLOR};
    font-weight: 900;
    font-family: ${FUTURA_BOLD};
    font-size: 1.85em;
    line-height: 1.25em;
    margin-bottom: 0.5em;
  }

  & > div.scan-id-description {
    width: 15em;
  }

  & > div.scan-id-error {
    color: ${ERROR_COLOR};
    font-weight: 900;
    font-family: ${FUTURA_BOLD};
    font-size: 1.5em;
    line-height: 1em;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LoginForm/styles.jsx